import { Stack, Switch, Typography } from '@mui/material';
import { Controller, FieldValues, Path, PathValue, Validate } from 'react-hook-form';

import { BaseInputProps } from './GetFormInput';

export function FormSwitch<T extends FieldValues>({
    control,
    disabled,
    helperText,
    label,
    required,
    validation,
    value,
}: Readonly<BaseInputProps<T>>) {
    return (
        <Controller
            control={control}
            name={value}
            render={({ field: { onBlur, onChange, ref, value }, fieldState: { error } }) => (
                <Stack
                    direction="row"
                    sx={{
                        alignItems: 'center',
                        border: '2px solid',
                        borderColor: error ? 'error.main' : 'primary.main',
                        borderRadius: 4,
                        p: 2,
                    }}
                >
                    <Stack
                        sx={{
                            flex: 1,
                        }}
                    >
                        <Stack
                            sx={{
                                maxWidth: '90%',
                            }}
                        >
                            <Typography sx={{ color: 'black', fontWeight: 'medium', mb: 0.5 }}>{label}</Typography>
                            <Typography variant="body2">{helperText}</Typography>
                            {error ? (
                                <Typography color="error" variant="body1">
                                    {error.message}
                                </Typography>
                            ) : null}
                        </Stack>
                    </Stack>
                    <Switch
                        checked={value as boolean}
                        disabled={disabled}
                        onBlur={onBlur}
                        onChange={onChange}
                        ref={ref}
                    />
                </Stack>
            )}
            rules={{
                required: required ? `${label ?? value} cannot be empty` : false,
                validate: validation as unknown as
                    | Validate<PathValue<T, Path<T>>, T>
                    | Record<string, Validate<PathValue<T, Path<T>>, T>>,
            }}
        />
    );
}
